/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Thirdparty modules usable by extension sets.
 */
export const extensionSetThirdPartyModules = {
  // "csstype": () => import("csstype"),
  "d3": () => import("d3"),
  "immutable": () => import("immutable"),
  "mobx": () => import("mobx"),
  "mobx-react": () => import("mobx-react"),
  "mobx-utils": () => import("mobx-utils"),
  "prop-types": () => import("prop-types"),
  "react": () => import("react"),
  "react-dom": () => import("react-dom"),
  "react-draggable": () => import("react-draggable"),
  "react-virtualized": () => import("react-virtualized")
};
//# sourceMappingURL=ExtensionSetThirdPartyModules.js.map
